import { useCallback } from 'react';
import { useDrawer } from '../../../../components/Drawer/useDrawer';
import type { EmitPageEventCta } from '../../../../components/Notifications/types';
import useInterfaceEventBus from '../../../hooks/useInterfaceEventBus';

type Params = {
  cta: EmitPageEventCta;
};

export const useEmitPageEventCtaAction = () => {
  const drawerContext = useDrawer();
  const hideDrawer = 'hide' in drawerContext ? drawerContext.hide : undefined;

  const { interfaceEventBus } = useInterfaceEventBus();

  const onClick = useCallback(
    ({ cta }: Params) => {
      if (!cta.eventName) {
        return;
      }

      hideDrawer?.();

      interfaceEventBus.publish('emitPageEventNotificationCta', {
        eventName: cta.eventName,
        eventPayload: cta.eventPayload,
      });
    },
    [hideDrawer, interfaceEventBus],
  );

  return onClick;
};
